const InfoMessage = ({ value, children = value || '' }) => (
  <label>
    <div className="info-message attached-icon form-control-feedback">
      <div>{children}</div>
    </div>
  </label>
)

export default (hoc) => hoc(InfoMessage)
